export default "__VITE_ASSET__V4IO2uLq__"